import Layout from '@/views/layout/index.vue'

const frameIn = [
    {
        path:'/',
        redirect:'/login',
    },
    {
        path: '/login', 
        component:()=> import('@/views/login/index.vue'), 
        hidden: true 
    },
    {
        path:'/dashboard',
        component:Layout,
        redirect:'/dashboard/index',
        children:[
           
            {
                path:'/dashboard/home-news',
                component:()=>import('@/views/dashboard/home_news.vue')
            },
            {
                path:'/dashboard/home-news-edit/:id?',
                component:()=>import('@/views/dashboard/home_news_edit.vue')
            },
            {
                path:'/dashboard/home-special',
                component:()=>import('@/views/dashboard/home_special.vue')
            },
            {
                path:'/dashboard/home-special-edit/:id?',
                component:()=>import('@/views/dashboard/home_special_edit.vue')
            },
            {
                path:'/dashboard/home-secondary',
                component:()=>import('@/views/dashboard/home_secondary.vue')
            },
            {
                path:'/dashboard/home-secondary-edit/:id?',
                component:()=>import('@/views/dashboard/home_secondary_edit.vue')
            },
            {
                path:'/dashboard/webpage',
                component:()=>import('@/views/dashboard/webpage.vue')
            },
            {
                path:'/dashboard/webpage-edit/:id?',
                component:()=>import('@/views/dashboard/webpage_edit.vue')
            },
            {
                path:'/dashboard/setting',
                component:()=>import('@/views/dashboard/setting.vue')
            },
            {
                path:'/dashboard/banner',
                component:()=>import('@/views/dashboard/banner.vue')
            },
            {
                path:'/dashboard/banner-edit/:id?',
                component:()=>import('@/views/dashboard/banner_edit.vue')
            }
        ],
        hidden:true
    },
    {
        path:'/member',
        component:Layout,
        redirect:'/member/index',
        children:[
            {
                path:'/member/index',
                component:()=>import('@/views/member/index.vue')
            },
            {
                path:'/member/news',
                component:()=>import('@/views/member/news.vue')
            },
            {
                path:'/member/news/detail/:id',
                component:()=>import('@/views/member/edit.vue')
            },
            {
                path:'/member/message',
                component:()=>import('@/views/member/message.vue')
            },
            
        ]
    },
     {//視頻
        path:'/video',
        component:Layout,
        redirect:'/video/index',
        children:[
            {
                path:'/video/index',
                component:()=>import('@/views/video/index.vue')
            },
            {
                path:'/video/edit/:id?',
                component:()=>import('@/views/video/edit.vue')
            },
        ]
    },
    {
        path:'/news',
        component:Layout,
        redirect:'/news/index',
        children:[
            {
                path:'/news/index',
                component:()=>import('@/views/news/index.vue')
            },
            {
                path:'/news/author',
                component:()=>import('@/views/news/author.vue')
            },
            {
                path:'/news/compare',
                component:()=>import('@/views/news/compare.vue')
            },
            {
                path:'/news/source',
                component:()=>import('@/views/news/source.vue')
            },
            {
                path:'/news/tags',
                component:()=>import('@/views/news/tags.vue')
            },
            {
                path:'/news/category',
                component:()=>import('@/views/news/category.vue')
            },
            {
                path:'/news/edit/:id?',
                component:()=>import('@/views/news/edit.vue')
            }
        ]
    },
    {
        path:'/feedback',
        component:Layout,
        redirect:'/feedback/index',
        children:[
            {
                path:'/feedback/index',
                component:()=>import('@/views/feedback/index.vue')
            },
            {
                path:'/feedback/report',
                component:()=>import('@/views/feedback/report.vue')
            }
        ]
    },
    {
        path:'/reptile',
        component:Layout,
        redirect:'/reptile/index',
        children:[
            {
                path:'/reptile/index',
                component:()=>import('@/views/reptile/index.vue')
            },
            {
                path:'/reptile/nindex',
                component:()=>import('@/views/reptile/nindex.vue')
            },
            {
                path:'/reptile/edit/:id?',
                component:()=>import('@/views/reptile/edit.vue')
            },
            {
                path:'/reptile/nedit',
                component:()=>import('@/views/reptile/nedit.vue')
            },
            {
                path:'/reptile/source',
                component:()=>import('@/views/reptile/source.vue')
            }
        ]
    },
    {
        path:'/manager',
        component:Layout,
        redirect:'/manager/index',
        children:[
            {
                path:'/manager/index',
                component:()=>import('@/views/manager/index.vue')
            }
        ]
    },
    {
        path:'/popup',
        component:Layout,
        redirect:'/popup/index',
        children:[
            {
                path:'/popup/index',
                component:()=>import('@/views/popup/index.vue')
            },
            {
                path:'/popup/edit/:id?',
                component:()=>import('@/views/popup/edit.vue')
            },
        ]
    },
]


export default [
    ...frameIn
];